import {Pane} from "evergreen-ui";
import React from "react";

export default function Operations({ children }) {
    return (
        <Pane
            display="grid"
            gridTemplateColumns="max-content 1fr"
        >
            {children}
        </Pane>
    );
}